import STable from './table'
import {
  cellForced,
  INDEX_CONFIG,
  PREFIX
} from '../config'
import { TableProps } from '../util/default-props'
import selectionMixin from '../extend/selection'
import FilterDropdown from '../extend/filter-dropdown'

export default {
  name: 'SyVcTable',
  components: {
    STable,
    FilterDropdown
  },
  props: {
    ...TableProps
  },
  mixins: [selectionMixin],

  data () {
    return {
      defaultSelection: { selectedRows: [] }
    }
  },
  watch: {
    dataSource (val, oldVal) {
      this.updateSelect(val !== oldVal)
    },
    columns: {
      handler (val) {
        this.renderFiltrate(val)
      },
      immediate: true
    }
  },

  methods: {

    // 判断有没有sy-columns
    findAssignColumn (columns, type = 'selection') {
      const selectIndex = columns.findIndex(column => column.type === type)
      const selectColumn = columns[selectIndex]
      selectColumn && columns.splice(selectIndex, 1)
      return selectColumn
    },
    
    // 渲染selection
    renderSelection (cols) {
      // 先判断 需不需要selection
      const columns = [...cols]
      const selectColumn = this.findAssignColumn(columns)
      if (this.rowSelection || selectColumn) {
        // 已经生成直接走缓存
        this.init()
        return this.renderRowSelection(columns, selectColumn)
      }
      return columns
    },

    // 筛选
    renderFiltrate (cols) {
      const columns = [...cols]
      let column
      for (let i = 0; i < columns.length; i++) {
        column = columns[i]
        if (column.type === 'filtrate') {
          column.title = <FilterDropdown column={column} title={column.title} colIndex={i}/>
          // 渲染默认
        }
      }
      return columns
    },

    // 展开更多
    renderExpand (cols) {
      const columns = [...cols]
      let column = this.findAssignColumn(columns, 'expand')

      return { expandColumn: column, columns }
    },

    // 渲染主体table
    renderTable () {
      const columnsWithRowSelection = this.renderSelection(this.columns)
      const { expandColumn, columns } = this.renderExpand(
        columnsWithRowSelection
      )
      const tProps = {
        props: {
          ...this.$props,
          columns,
          expandColumn
        }
      }
      return <STable {...tProps} />
    },

    // 分页
    handleSizeChange (val) {
      console.log(val)
    }
  },

  render (h) {
    // console.log('==================vc===============')
    return (
      <div class={`${PREFIX}-outer ${PREFIX}-table-div`}>
        {this.renderTable()}
      </div>
    )
  },

  // 销毁
  destroy () {
    this.selectStore = null
  }
}
